import { PropTypes } from "prop-types";
import DeleteIcon from "../../../assets/img/icons/delete.svg";
import EditIcon from "../../../assets/img/icons/edit-black.svg";
import { StyledDirectionTable } from "../../../styles/StyledDecision/StyledContent";
import AddIcon from "../../../assets/img/icons/add.svg";
import { Button } from "../../Button";

export default function MeetingPoint({
	order,
	id,
	data,
	openModal,
	openEditModal,
	setDeletedId,
	setEditedId,
	openMinuteModal,
	setMinuteId,
}) {
	return (
		<StyledDirectionTable sizes={[2.8, 23.5, 36, 13.5, 7, 17.2]}>
			<span>{order}.</span>
			<span>{data.title}</span>
			<span>{data.details}</span>
			<span>{data?.decision ? data.decision.name : "None"}</span>
			<div>
				<img
					onClick={() => {
						setEditedId(id);
						openEditModal();
					}}
					src={EditIcon}
					alt={EditIcon}
					role="img"
				/>
				<img
					onClick={() => {
						if (openModal) {
							setDeletedId(id);
							openModal();
						}
					}}
					src={DeleteIcon}
					alt={DeleteIcon}
					role="img"
				/>
			</div>
			<span
				className="text-button"
				onClick={() => {
					setMinuteId(id);
					openMinuteModal();
				}}
			>
				{data.minutes && (
					<>
						<span>{data.minutes}</span>
						<Button icon={EditIcon} bg={false} small></Button>
					</>
				)}
				{!data.minutes && (
					<Button icon={AddIcon} bg={false} small>
						Minute
					</Button>
				)}
			</span>
		</StyledDirectionTable>
	);
}

MeetingPoint.propTypes = {
	order: PropTypes.number,
	id: PropTypes.string,
	data: PropTypes.object,
	openModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	openEditModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	openMinuteModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	setDeletedId: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	setEditedId: PropTypes.func,
	setMinuteId: PropTypes.func,
};

MeetingPoint.defaultProps = {
	openModal: false,
	setDeletedId: false,
};
